import { HStack, SimpleGrid, Text, Box } from "@chakra-ui/react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { formatFieldTypeValue } from "utils/helpers";

function getRowOfCell(cellIndex: number, columns: number) {
  var rowIndex = Math.floor(cellIndex / columns);
  return rowIndex;
}

export function isEvenRow(cellIndex: number, columns: number) {
  const row = getRowOfCell(cellIndex, columns);
  return row === 0 ? true : row % 2 === 0;
}

export function mapLoanValues(values: any[]) {
  return values.reduce((acc: any, obj: any) => {
    acc[obj.loan_field.id] = obj.value.field;
    return acc;
  }, {});
}

const FieldsTable = ({
  fields,
  columns = 2,
  id,
}: {
  fields: any;
  columns?: number;
  id?: string;
}) => {
  const { user } = useTenant();

  const getValueByFieldId = (fieldId: any) => {
    const field = fields.find((field: any) => field.id === fieldId);
    if (field) {
      const values = field.values;
      if (values && values[0]?.borrower) {
        if (values && values.length > 0 && values[0]?.borrower === id) {
          return formatFieldTypeValue(field.type, values[0]?.value?.field, user);
        }
      } else if (values && values.length > 0) {
        return formatFieldTypeValue(field.type, values[0]?.value?.field, user);
      }
    }
    return null;
  };

  return (
    <Box>
      <SimpleGrid columns={columns} spacingX="20px">
        {fields &&
          fields.length > 0 &&
          fields
            .sort((a: any, b: any) => a.id - b.id)
            .map((field: any, index: number) => (
              <HStack
                key={field.id}
                w="100%"
                bg={isEvenRow(index, columns) ? "#F9F8F8" : "white"}
                px="12px"
                alignItems="center"
                justifyContent="space-between"
                pl="13px"
                py="15px"
                fontWeight="500"
                fontSize="14px"
                color="black"
                borderRadius="6px"
              >
                <Text>{field.label}</Text>
                <Text
                  textAlign="right"
                  fontWeight="400"
                  fontSize="16px"
                  lineHeight="28px"
                  color="secondary"
                >
                  {getValueByFieldId(field.id) ?? ""}
                </Text>
              </HStack>
            ))}
      </SimpleGrid>
    </Box>
  );
};

export default FieldsTable;
